/**
 * Étapes des tutoriels de page, écrites pour tous les rôles et tous les écrans : le
 * moteur écarte celles dont la cible est absente. Pas de branche par rôle à maintenir.
 */
import i18n from "../../../i18n/i18n";
import { anchoredStep, compactSteps, TourStep } from "../tourEngine";

/** Page Produits. */
export const devicesTourSteps = (): TourStep[] =>
  compactSteps([
    {
      popover: {
        title: i18n.t("tour-devices-intro-title"),
        description: i18n.t("tour-devices-intro-text"),
      },
    },
    anchoredStep(["#tour-devices-header"], {
      popover: {
        title: i18n.t("tour-devices-header-title"),
        description: i18n.t("tour-devices-header-text"),
        side: "bottom",
        align: "start",
      },
    }),
    anchoredStep(["#tour-devices-filters"], {
      popover: {
        title: i18n.t("tour-devices-filters-title"),
        description: i18n.t("tour-devices-filters-text"),
        side: "bottom",
        align: "start",
      },
    }),
    // Tableau sur desktop, cartes sur mobile : une seule des deux cibles est visible.
    anchoredStep(["#tour-devices-list", "#tour-devices-list-mobile"], {
      popover: {
        title: i18n.t("tour-devices-list-title"),
        description: i18n.t("tour-devices-list-text"),
        side: "top",
        align: "center",
      },
    }),
  ]);

/** Page Partenaires. */
export const partnershipsTourSteps = (): TourStep[] =>
  compactSteps([
    {
      popover: {
        title: i18n.t("tour-partnerships-intro-title"),
        description: i18n.t("tour-partnerships-intro-text"),
      },
    },
    anchoredStep(["#tour-partnerships-header"], {
      popover: {
        title: i18n.t("tour-partnerships-request-title"),
        description: i18n.t("tour-partnerships-request-text"),
        side: "bottom",
        align: "start",
      },
    }),
    // Sections rendues seulement si non vides : un compte neuf n'en a aucune.
    anchoredStep(["#tour-partnerships-to-respond"], {
      popover: {
        title: i18n.t("tour-partnerships-to-respond-title"),
        description: i18n.t("tour-partnerships-to-respond-text"),
        side: "top",
        align: "start",
      },
    }),
    anchoredStep(["#tour-partnerships-active"], {
      popover: {
        title: i18n.t("tour-partnerships-active-title"),
        description: i18n.t("tour-partnerships-active-text"),
        side: "top",
        align: "start",
      },
    }),
    anchoredStep(["#tour-partnerships-sent"], {
      popover: {
        title: i18n.t("tour-partnerships-sent-title"),
        description: i18n.t("tour-partnerships-sent-text"),
        side: "top",
        align: "start",
      },
    }),
  ]);

/** Page Élevages (espace éleveur). */
export const breedingsTourSteps = (): TourStep[] =>
  compactSteps([
    {
      popover: {
        title: i18n.t("tour-breedings-intro-title"),
        description: i18n.t("tour-breedings-intro-text"),
      },
    },
    anchoredStep(["#tour-breedings-header"], {
      popover: {
        title: i18n.t("tour-breedings-actions-title"),
        description: i18n.t("tour-breedings-actions-text"),
        side: "bottom",
        align: "start",
      },
    }),
    anchoredStep(["#tour-breedings-list"], {
      popover: {
        title: i18n.t("tour-breedings-list-title"),
        description: i18n.t("tour-breedings-list-text"),
        side: "top",
        align: "center",
      },
    }),
  ]);

/** Page Mon compte. */
export const profileTourSteps = (): TourStep[] =>
  compactSteps([
    {
      popover: {
        title: i18n.t("tour-profile-intro-title"),
        description: i18n.t("tour-profile-intro-text"),
      },
    },
    anchoredStep(["#tour-profile-avatar"], {
      popover: {
        title: i18n.t("tour-profile-avatar-title"),
        description: i18n.t("tour-profile-avatar-text"),
        side: "right",
        align: "start",
      },
    }),
    anchoredStep(["#nav-profile-security"], {
      popover: {
        title: i18n.t("tour-profile-security-title"),
        description: i18n.t("tour-profile-security-text"),
        side: "right",
        align: "start",
      },
    }),
    anchoredStep(["#tour-profile-form"], {
      popover: {
        title: i18n.t("tour-profile-form-title"),
        description: i18n.t("tour-profile-form-text"),
        side: "right",
        align: "start",
      },
    }),
  ]);
